module.exports = __webpack_public_path__ + "static/media/lang-en.6e6f9478.svg";